import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as TriangleIcon } from 'common-assets/assets/icons/triangleArrowDown.svg';
import { Accordion, AriaHeadingLevel, Icon, Typography } from 'ui-components';
import {
  CALC_OUTCOME_TEST_ID,
  OUTCOME_ASSUMPTION_KEYS,
  RETIREMENT_CALCULATOR_NAMESPACE,
} from '../../tools/RetirementCalculator.const';

import useStyles from './RetirementCalculatorOutcome.style';

export const RetirementCalculatorOutcomeAssumptions: React.FC = () => {
  const c = useStyles({});
  const [t] = useTranslation(RETIREMENT_CALCULATOR_NAMESPACE, { useSuspense: false });

  return (
    <Accordion
      title={t('outcome.assumptions.title')}
      expandElement={
        <Icon className={c.assumptionsIcon}>
          <TriangleIcon />
        </Icon>
      }
      className={c.assumptions}
      summaryClassName={c.assumptionsSummary}
      titleClassName={c.assumptionsTitle}
      detailsClassName={c.assumptionsDetails}
      transparent={true}
      variant="heading"
      ariaLevel={AriaHeadingLevel.H3}
      autoTestId={`${CALC_OUTCOME_TEST_ID}-assumptions`}
    >
      <ul className={c.assumptionsList}>
        {OUTCOME_ASSUMPTION_KEYS.map(key => (
          <li key={key} className={c.assumptionsItem}>
            <Typography variant="body1" component="span">
              {t(`outcome.assumptions.items.${key}`)}
            </Typography>
          </li>
        ))}
      </ul>
    </Accordion>
  );
};
